// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b06868b9","977":"c3d99690"}[chunkId] + ".chunk.js";
};